import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const promotecourseApiService = createApi({
  reducerPath: "promotecourseApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createPromoteCourse: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `promotecourse/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
});

export const { useCreatePromoteCourseMutation } = promotecourseApiService;
